import {Operation} from "./Operation.js";


export class Add extends Operation {

    static symbol = "+";

    /**
     * Perform addition on the two values.
     * @param {Row} row - A row object containing the values to add.
     * @returns {number} The sum of the two values.
     */
    perform(row) {
        const [leftValue, rightValue] = this.getOperands(row);
        return (leftValue || 0) + (rightValue || 0);
    }
}